const VUE_APP_API_TOTALMANAGE_URL = document.querySelector("body").getAttribute("api_totalmanage_url");

export default VUE_APP_API_TOTALMANAGE_URL
